import React from 'react';

type LayerAnalyticsGridContentProps = {
  label: string;
  value: React.ReactNode;
};

/**
 * One bordered, rounded figure box (muted label over a bold value), 3 lines
 * tall. Place several inside <LayerAnalyticsGrid>: they share the row equally
 * and wrap onto a new row when it gets too narrow.
 */
export const LayerAnalyticsGridContent: React.FC<
  LayerAnalyticsGridContentProps
> = ({ label, value }) => (
  <div className="d-flex flex-column justify-content-center tw:h-[calc(3lh+2px)] tw:min-w-0 tw:grow tw:basis-28 rounded border px-3">
    <span className="text-muted text-truncate" title={label}>
      {label}
    </span>
    <span className="fw-bold text-truncate">{value}</span>
  </div>
);

export const LayerAnalyticsGrid: React.FC<React.PropsWithChildren> = ({
  children,
}) => <div className="d-flex flex-wrap gap-3">{children}</div>;
